import { Divider, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {
  getSelectedCustomerName,
  getSelectedCustomerId,
} from "@features/customers/customerSlice";
import { getSelectedTaskName } from "@features/tasks/tasksSlice";
import { RootState } from "@app/store";
import { useLocation } from "react-router-dom";

const LogoBar = () => {
  const location = useLocation();
  const customerName = useSelector<RootState, string>(
    getSelectedCustomerName,
    shallowEqual,
  );
  const customerId: string = useSelector(getSelectedCustomerId);
  const taskName = useSelector<RootState>(getSelectedTaskName);

  const isTasksView = location.pathname.includes(`${customerId}/tasks`);

  return (
    <Box
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "20px",
      }}
    >
      <Link to={"/"}>
        <img
          alt="logo"
          src={require("@assets/dolphin-logo.png")}
          style={{
            boxSizing: "content-box",
            height: "35px",
            marginTop: "7px",
          }}
        />
      </Link>
      {!!customerName ? (
        <Divider
          orientation="vertical"
          variant="middle"
          sx={{ backgroundColor: "white" }}
          flexItem
        />
      ) : null}
      <Typography variant="h2">
        {`${customerName} ${isTasksView && !!taskName ? ` - ${taskName}` : ""}`}
      </Typography>
    </Box>
  );
};

export default LogoBar;
